import React, { useContext, useMemo } from 'react';
import { object } from 'prop-types';
import { Link } from 'react-router-dom';
import constants from '../constants.json' assert { type: 'json' };
import useDynamicPath from '../hooks/useDynamicPath';
import '../styles/ChildCategories.css';
import AppContext from './context/AppContext';
function ChildCategories ({ hierarchy }) {
    const { appContext } = useContext(AppContext);
    const collectionPath = useDynamicPath({ pathName: constants.DYNAMIC_PATHS.COLLECTION_PATH });
    const current = hierarchy.default?.filter(category => category.LEVEL === 2);
    const hasImage = useMemo(() => hierarchy?.default?.some((category) => category.LEVEL === 2 && category.imageUrl), [hierarchy]);
    const appConfig = appContext.config.themeConfig;
    if (!current?.length) {
        return null;
    }

    return (
        <div
            className={'categories-section'}>
            {!hasImage ? (
                <>
                    <h2
                        className={'categories-heading'}>Categories</h2>
                    <div
                        className={'subcollections-list-container'}>
                        {current
                            .map(({ id, title, handle }) => (
                                <div
                                    key={id}
                                    className={'subcollection-list-item'}
                                >
                                    <Link
                                        className={'subcollection-link'}
                                        to={`${collectionPath[0].pathBeforeParams}/${handle}`}
                                    >
                                        {title}
                                    </Link>
                                </div>
                            ))
                        }
                    </div>
                </>
            ) : (
                <div
                    className={'subcollections-list-container'}>
                    <ul
                        className={'side-menu'}>
                        {current
                            .map(({ id, title, handle, imageUrl }) => (
                                <li
                                    key={id}
                                    className={'subcollection-expanded-list-item'}>
                                    <Link
                                        to={`${collectionPath[0].pathBeforeParams}/${handle}`}>
                                        <img
                                            src={imageUrl ?? appConfig.collectionNoImageUrl}
                                            alt={title}
                                            className={'subcollection-image'}
                                        />
                                    </Link>
                                    <Link
                                        className={'subcollection-label'}
                                        to={`${collectionPath[0].pathBeforeParams}/${handle}`}>
                                        {title}
                                    </Link>
                                </li>
                            ))
                        }
                    </ul>
                </div>
            )}
        </div>
    );
}

ChildCategories.propTypes = {
    hierarchy: object,
};

export default ChildCategories;